// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"8881889f","403":"74db0490","453":"1a526e2b","457":"fc630717","510":"f1a542df","636":"ccf0f37a","752":"064a0eb0","780":"09d13b02"}[chunkId] + ".chunk.js";
};